<script>
	import clsx from 'clsx'

	export let condense = false
</script>

<div class={clsx('box', condense && 'view-condense')}>
	<slot />
</div>
